import React from "react";
import { Link } from "react-router-dom";
import { Stethoscope, Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";

export const Footer = () => {
  const { lang } = useApp();
  return (
    <footer className="mt-20 bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 font-heading font-bold text-white text-lg">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center">
              <Stethoscope size={20}/>
            </div>
            AASAN <span className="text-blue-400">OPD</span>
          </div>
          <p className="text-sm mt-3 text-slate-400">{t(lang, "footer.about")}</p>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3">{t(lang, "footer.quickLinks")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/book/ultrasound" className="hover:text-blue-400">{t(lang, "nav.ultrasound")}</Link></li>
            <li><Link to="/book/opd" className="hover:text-blue-400">{t(lang, "nav.opd")}</Link></li>
            <li><Link to="/book/mri" className="hover:text-blue-400">{t(lang, "nav.mri")}</Link></li>
            <li><Link to="/pharmacy" className="hover:text-blue-400">{t(lang, "nav.pharmacy")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3">{t(lang, "footer.legal")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/terms" className="hover:text-blue-400">{t(lang, "footer.terms")}</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-blue-400">{t(lang, "footer.privacy")}</Link></li>
            <li><Link to="/legal/refund" className="hover:text-blue-400">{t(lang, "footer.refund")}</Link></li>
            <li><Link to="/legal/help" className="hover:text-blue-400">{t(lang, "footer.help")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3">{t(lang, "footer.contact")}</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Phone size={14}/> +91 9798203741</li>
            <li className="flex items-center gap-2"><Mail size={14}/> care@aasanopd.in</li>
            <li className="flex items-center gap-2"><MapPin size={14}/> Begusarai, Bihar 851101</li>
            <li>
              <a
                href="https://wa.me/919798203741"
                target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 mt-2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 hover:bg-emerald-500/20"
              >
                <MessageCircle size={14}/> WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} AASAN OPD. {t(lang, "footer.rights")}.
      </div>
    </footer>
  );
};
